import styled from 'styled-components';

const LandingPageHolder = styled.div`
	grid-area: content;
	padding: 0;
	overflow: hidden;

	.row {
		clear: both;
		display: flex;
		justify-content: space-around;
		flex-flow: row;
		align-items: stretch;
		img {
			max-width: 960px;
			@media (max-width: 767px) {
				max-width: auto;
			}
		}
	}
	.bg-white {
		background-color: #fff;
	}
	.lp-video-container,
	.lp-thumbnail-container {
		margin: 0 auto;
		display: block;
		overflow: hidden;
		width: 100%;
		padding: 20px 0 0 0;
		position: relative;
		.lp-video-player,
		.lp-thumbnail {
			position:relative;
			max-width: 900px;
			margin: 0 auto 1rem;
			text-align: center;
			> :first-child {
				border: none;
			}
			img {
				width: 100%;
			}
		}
	}
	.lp-podcasts {
		padding: 2rem 0 1rem;
		@media (max-width: 767px) {
			div {
				padding: 0 !important;
			}
		}
		p {
			max-width: 900px;
			margin: 1rem auto;
			text-align: center;
			&.lp-podcast-listen {
				text-transform: uppercase;
			}
			&.lp-small-print {
				font-size: 12px;
				max-width: 30rem;
			}
		}
		.lp-podcast-logos {
			max-width: 40rem;
			margin: 0 auto;
			display: flex;
			flex-direction: row;
			justify-content: space-evenly;
			padding-left: 2.25rem;
			@media (max-width: 767px) {
				padding-left: 0;
				flex-direction: column;
				text-align: center;
			}
		}
	}	
	.lp-aboutLinks {
		max-width: 900px;
		text-align: center;
		margin: 2rem auto 1rem;
		text-transform: uppercase;
		.btn--abouts {
			font-weight: 400;
			font-size: 1rem;
			color:#fdfdfc;
			background: #726b55;
			border: solid 5px #d1cdc1;
			transition: all 0.2s ease-in;
			border-radius: 2em;
			padding: .5rem 1rem;
    		text-transform: uppercase;
			cursor: pointer;
			&:hover {
				background: #a69e87;
				border: solid 5px #a69e87;
				transition: all 0.2s ease-in;
			}
		}
	}
	.lp-abouts {
		display: flex;
		flex-direction: row;
		max-width: 60rem;
		margin: 2rem auto;
		height: auto;
		@media (max-width: 767px) {
			flex-direction: column;
		}
		.lp-aboutShow,
		.lp-aboutHost {
			width: 50%;
			padding: 0 1rem 0 0; 
			@media (max-width: 767px) {
				width: 100%;
				padding: 0 2rem;
			}
			&.full {
				width: 100%;
				.lp-about-host-label {
					width: 100%;
				}
			}
			p {
				padding: 5px;
			}
		}
		&.closed {
			height: 0;
			overflow: hidden;
		}
		.lp-about-host-label {
			color: #fff;
			background: #5f7586 url(/static-assets/theme/svg/left-decoration.svg) center left -2px no-repeat;
			background-size: auto 110%;
			padding: 8px 20px 8px 40px;
			width: 95%;
			border-radius: 2em;
			text-transform: uppercase;
			margin: 40px 0 20px;
			font-size: 20px;
			@media (max-width: 767px) {
				margin: 20px auto;
				width: 100%;
			}
		}
		.host-image-container {
			padding-top: 0 !important;
			display: block;
			margin: 0;
			position:relative;
			img {
				max-width: 100%;
				margin-top: 1px;
				
			}
		}
		.lp-host-content-wrap {
			.lp-host-content{
				
			}
		}
	}
	.share-container {
		text-align: center;
		margin-bottom: 2rem;
	}
	
	.hn__content {
		li {
			margin-bottom: 0 !important;
		}
	}
	.lp-video-player .video-live-label {
		position: absolute !important;
		top: 0;
		left: .7%;
		img {
			width: 24px;
		}
	}
`;

export default LandingPageHolder;